import(/* webpackMode: "eager" */ "/var/www/716-cannabis/app/blog/[slug]/page.tsx");
